import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialFlipVerticalDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 1.53h-1.52v13.71h-1.52v1.52H32v-1.52h-1.53zm-1.52 24.38h1.52v4.57h-1.52Zm0-7.62h1.52v4.57h-1.52ZM3.05 0h25.9v1.53H3.05Zm21.33 30.48h4.57V32h-4.57Zm-1.53-15.24h3.05v1.52h-3.05Zm-10.66 4.57v1.53h-1.53v1.52h10.67V12.19h-1.52v1.53h-1.53v1.52h-1.52v-1.52h-1.52v-3.05h1.52V9.15h3.05V7.62h-6.1v1.53h-1.52v3.04h-1.53v4.57h1.53v1.53h1.52v1.52zm4.57 10.67h4.57V32h-4.57Zm-6.1 0h4.58V32h-4.58ZM6.09 15.24h3.05v1.52H6.09ZM3.05 30.48h4.57V32H3.05Zm-1.53-4.57h1.53v4.57H1.52Zm0-7.62h1.53v4.57H1.52Zm0-3.05H0v1.52h4.57v-1.52H3.05V1.53H1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialFlipVerticalDown
